export default (
    <svg xmlns="http://www.w3.org/2000/svg">
        <path
            fill={'red'}
            d="M6.211 3.578a2 2 0 0 1 3.578 0l2.764 5.528A2 2 0 0 1 10.764 12H5.236a2 2 0 0 1-1.789-2.894Z"
        />
        <path d="M4.211 4.578a2 2 0 0 1 3.578 0l2.764 5.528A2 2 0 0 1 8.764 13H3.236a2 2 0 0 1-1.789-2.894Z" />
    </svg>
)
